import React, { useMemo } from "react";
import { Select } from "../../../../../shared/Select/Select";
import { useShopifySearchProducts } from "../../../../../api/queries/useShopifySearchProducts";
import { useDebouncedState } from "../../../../../utilities/hooks/useDebouncedState";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";

const ProductSelect = ({ value, onSelect }) => {
  const { tCommon } = useAppTranslation.Common();

  const [search, debouncedSearch, setSearch] = useDebouncedState(
    value?.label || "",
  );

  const { data, isLoading, isFetching } = useShopifySearchProducts({
    payload: {
      title: debouncedSearch,
    },
  });

  const options = useMemo(() => {
    return (
      data?.map((product) => ({
        label: product.title,
        value: product.id,
      })) || []
    );
  }, [data]);

  return (
    <Select
      isSearchable
      inputValue={search}
      isLoading={isLoading || isFetching}
      size="small"
      options={options}
      onChange={onSelect}
      onInputChange={setSearch}
      noOptionsMessage={tCommon("label.startTyping")}
    />
  );
};

export default ProductSelect;
